import './App.css';
import {BrowserRouter, Routes, Route, Link} from 'react-router-dom';
import ScrollToTop from '../src/components/ScrollToTop';
import Home from './pages/home';
import About from './pages/about';
import Contact from './pages/contact';
import Gallery from './pages/gallery';
import DigitalFiles from './pages/digitalfiles';
import SpecialOffer from './pages/specialoffer';
import Solutions from './pages/Solutions';
import Projects from './pages/projects';
import ProjectDetails from './pages/ProjectDetails';
import TechInfo from './pages/TechInfo';

function App() {
  return (
    <BrowserRouter>
    <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/gallery" element={<Gallery/>}/>
        <Route path="/gallery/:solutionName" element={<Solutions/>}/>
        <Route path="/gallery/:solutionName/:sub1" element={<Solutions/>}/>
        <Route path="/gallery/:solutionName/:sub1/:sub2" element={<Solutions/>}/>
        <Route path="/send-digital-files" element={<DigitalFiles/>}/>
        <Route path="/request-special-offer" element={<SpecialOffer/>}/>
        <Route path="/projects" element={<Projects/>}/>
        <Route path="/projects/:projectSlug" element={<ProjectDetails />} />
        <Route path="/tech-info" element={<TechInfo/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
